import { createSlice } from '@reduxjs/toolkit'

export const AcceptedReducer = createSlice({
    name: 'acceptedData',
    initialState: {
        AcceptedData: null,
    },
    reducers: {
        setAcceptedData: (state, action) => {
            state.AcceptedData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setAcceptedData } = AcceptedReducer.actions

export default AcceptedReducer.reducer